import { useEffect, useState } from 'react'
import axiosInterceptorInstance from 'api/client'
import { socketInstance } from 'lib/socket'

// Tracks the API maintenance flag and live socket updates.
export const useMaintenanceStatus = () => {
  const [isInMaintenance, setIsInMaintenance] = useState(false)

  useEffect(() => {
    try {
      axiosInterceptorInstance.get('/maintenance/status').then((data) => {
        setIsInMaintenance(data.data?.isActive)
      })
    } catch (error) {
      // ignored — matches master's original inline implementation
    }
  }, [])

  useEffect(() => {
    const handleMaintenanceChange = (status) => setIsInMaintenance(status)

    socketInstance.on('maintenance-status-changed', handleMaintenanceChange)

    return () => {
      socketInstance.off('maintenance-status-changed', handleMaintenanceChange)
    }
  }, [])

  return { isInMaintenance }
}
